export const pendingCAStatusCode = {
  TAGGING: "1",
  UNTAGGING: "2",
  UPDATING: "3",
};
